(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // refs
    this.header = null;
    this.headerSection = null;
    this.predictiveSearch = null;

    // state
    this.headerBounds = { top: 0 };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.isScrolling = null;

    // cached geometry (filled ONLY after user intent)
    this.headerGroupHeight = 0;
    this.headerHeight = 0;
    this.headerBottomAbs = 0;
    this.stickyType = 'disable';
    this._collapseLastY = 0;
    this._collapseCooldown = 0;

    // raf
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._rafMeasure = 0;
    this._needsMeasure = false;

    // observers (created ONLY after start)
    this.resizeObserver = null;
    this.io = null;

    // flags
    this._started = false;

    // binds
    this._onScrollEvent = this._onScrollEvent.bind(this);
    this._flushScroll = this._flushScroll.bind(this);

    this._scheduleMeasure = this._scheduleMeasure.bind(this);
    this._flushMeasure = this._flushMeasure.bind(this);

    this._onSectionLoad = this._onSectionLoad.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    // wake handlers (NO layout reads)
    this._wake = this._wake.bind(this);
    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);

    this.handleScrollOnce = this.handleScrollOnce.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    window.removeEventListener('scroll', this._onScrollEvent);

    document.removeEventListener('shopify:section:load', this._onSectionLoad);
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this.resizeObserver) {
      try { this.resizeObserver.disconnect(); } catch(e) {}
      this.resizeObserver = null;
    }

    if (this.io) {
      try { this.io.disconnect(); } catch(e) {}
      this.io = null;
    }

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    if (this._rafMeasure) cancelAnimationFrame(this._rafMeasure);
    this._rafScroll = 0;
    this._rafMeasure = 0;

    this._started = false;
  }

  _wakeOnScroll() { this._wake('scroll'); }
  _wakeOnPointer() { this._wake('pointer'); }
  _wakeOnKey() { this._wake('key'); }

  _wake(_reason) {
    if (this._started) return;
    this._started = true;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this._start();
  }

  _start() {
    this.header =
      document.getElementById('shopify-section-header') ||
      document.querySelector('.shopify-section-header') ||
      null;

    if (!this.header) return;

    this.headerSection = this.header.querySelector('.header') || this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.stickyType = this.headerSection?.dataset?.stickyType || 'disable';

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    this.onScrollHandler = (this.stickyType === 'on_scroll')
      ? this._onScrollLogic.bind(this)
      : this._onAlwaysScrollLogic.bind(this);

    window.addEventListener('scroll', this._onScrollEvent, { passive: true });
    document.addEventListener('shopify:section:load', this._onSectionLoad);
    window.addEventListener('scroll', this.handleScrollOnce, { passive: true });

    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.currentScrollTop = this._pendingScrollTop;
    this._collapseLastY = this._pendingScrollTop;

    this._scheduleMeasure();

    if (this.stickyType !== 'disable') {
      this._createIntersectionObserver();
      this._createResizeObserver();
    }

    this.onScrollHandler();

    /* Wire collapsed-bar icons to mirror original header behaviour */
    this._initCollapsedBarIcons();
  }

  _initCollapsedBarIcons() {
    if (!this.header) return;
    const bar = this.header.querySelector('.bottom-bar__icons');
    if (!bar) return;

    /* Helper: un-collapse, hold header open, then trigger original element */
    const _triggerOriginal = (selector, fallbackHref) => {
      const original = this.header.querySelector(selector);
      if (original) {
        this.header.classList.remove('header--collapsed');
        this._collapseCooldown = performance.now() + 1200;
        requestAnimationFrame(() => original.click());
      } else if (fallbackHref) {
        window.location.href = fallbackHref;
      }
    };

    /* Burger -> un-collapse then fire original burger button */
    const burgerBtn = bar.querySelector('.bottom-bar__burger');
    if (burgerBtn) {
      burgerBtn.addEventListener('click', () => {
        _triggerOriginal('.main-header .burger-js[data-modal-toggle-menu-dawer]');
      });
    }

    /* Search icon -> open the original header search modal */
    const searchBtn = bar.querySelector('.bottom-bar__search');
    if (searchBtn) {
      searchBtn.addEventListener('click', (e) => {
        e.preventDefault();
        _triggerOriginal('.main-header .search details summary, .main-header .search-link', searchBtn.getAttribute('href'));
      });
    }

    /* Cart icon -> trigger original header cart (opens drawer) */
    const cartLink = bar.querySelector('.cart-icon a.cart, a.cart');
    if (cartLink) {
      cartLink.addEventListener('click', (e) => {
        e.preventDefault();
        _triggerOriginal('.main-header .cart-icon a.cart, .main-header a.cart', cartLink.getAttribute('href'));
      });
    }
  }


  _onScrollEvent() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._flushScroll);
  }

  _flushScroll() {
    this._rafScroll = 0;
    if (this.onScrollHandler) this.onScrollHandler();
  }

  _scheduleMeasure() {
    this._needsMeasure = true;
    if (this._rafMeasure) return;
    this._rafMeasure = requestAnimationFrame(this._flushMeasure);
  }

  _flushMeasure() {
    this._rafMeasure = 0;
    if (!this._needsMeasure) return;
    this._needsMeasure = false;
    this._setHeaderHeight();
  }

  _setHeaderHeight() {
    if (!this.header || !this.headerSection) return;

    const g1 = this.header.previousElementSibling;
    const g2 = g1 ? g1.previousElementSibling : null;
    const g3 = g2 ? g2.previousElementSibling : null;

    const inner = this.header.querySelector('.header') || this.headerSection;

    let total = inner ? inner.offsetHeight : 0;
    if (g1) total += g1.offsetHeight;
    if (g2) total += g2.offsetHeight;
    if (g3) total += g3.offsetHeight;

    this.headerGroupHeight = total;
    this.headerHeight = this.headerSection.offsetHeight || 0;

    document.documentElement.style.setProperty('--header-height', `${this.headerGroupHeight}px`);
    document.documentElement.style.setProperty(
      '--sticky-header-height',
      this.stickyType === 'disable' ? '0px' : `${this.headerHeight}px`
    );

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const rect = this.headerSection.getBoundingClientRect();
    this.headerBottomAbs = rect.bottom + scrollTop;

    if (!this.headerBounds || typeof this.headerBounds.top !== 'number') {
      this.headerBounds = { top: rect.top + scrollTop };
    }
  }

  _onSectionLoad(event) {
    if (
      event?.target?.closest?.('.shopify-section-header') ||
      event?.target?.closest?.('.shopify-section-announcement-bar')
    ) {
      this._scheduleMeasure();
      this._onScrollEvent();
    }
  }

  _createResizeObserver() {
    if (this.resizeObserver || !this.headerSection) return;
    this.resizeObserver = new ResizeObserver(() => {
      this._scheduleMeasure();
    });
    this.resizeObserver.observe(this.headerSection);
  }

  _createIntersectionObserver() {
    if (this.io || !this.headerSection) return;

    this.io = new IntersectionObserver((entries, observer) => {
      const e = entries && entries[0];
      if (e && e.intersectionRect) this.headerBounds = e.intersectionRect;
      else this.headerBounds = { top: 0 };
      observer.disconnect();
      this.io = null;
    });

    this.io.observe(this.headerSection);
  }

  handleScrollOnce() {
    const shopifySection = this.header;
    if (!shopifySection) {
      window.removeEventListener('scroll', this.handleScrollOnce);
      return;
    }

    const cls = shopifySection.className || '';
    const w = window.innerWidth;

    const overlapEnabled =
      cls.includes('overlap-enable') ||
      (cls.includes('overlap-desktop') && w > 1024) ||
      (cls.includes('overlap-mobile') && w < 1025);

    if (overlapEnabled) {
      const st = window.scrollY || document.documentElement.scrollTop || 0;
      if (st > 5) shopifySection.classList.add('animate');
    }

    window.removeEventListener('scroll', this.handleScrollOnce);
  }


  disableTransitionForMs(ms) {
    if (!this.header) return;
    this.header.classList.add('transition-none');
    setTimeout(() => {
      if (this.header) this.header.classList.remove('transition-none');
    }, ms);
  }

  _onScrollLogic() {
    if (!this.header || !this.headerSection) return;

    if (document.body.classList.contains('disable-scroll') ||
        document.body.classList.contains('disable-scroll-body')) return;
    if (document.body.classList.contains('after-focusout')) return;

    const scrollTop = this._pendingScrollTop;

    if (scrollTop <= 0) {
      this.reset();
      this.currentScrollTop = 0;
      return;
    }

    if (this.querySelector('details-dropdown[open]')) {
      if (!this.header.classList.contains('shopify-section-header-sticky')) {
        this.disableTransitionForMs(300);
      }

      if (scrollTop >= (this.headerBounds?.top || 0)) {
        this.header.classList.remove('shopify-section-header-sticky', 'animate', 'disable-visibility');
      }

      const delta = scrollTop - (this.currentScrollTop ?? 0);
      if (delta < 0) this.header.classList.add('shopify-section-header-sticky', 'animate');

      this.currentScrollTop = scrollTop;
      return;
    }

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    const headerBottom = this.headerBottomAbs || (this.headerHeight ? (this.headerHeight + 1) : 0);

    if (scrollTop > this.currentScrollTop + 3 && scrollTop > (this.headerGroupHeight || 0)) {
      this.hide();
    } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
      if (!this.preventReveal) {
        this.reveal();
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this.hide();
      }
    } else if (scrollTop <= (this.headerBounds?.top || 0)) {
      this.reset();
    }

    this.currentScrollTop = scrollTop;
  }

  _onAlwaysScrollLogic() {
    if (!this.header) return;

    const scrollTop = this._pendingScrollTop;

    if (scrollTop > 5) this.header.classList.add('animate');
    if (
      scrollTop < 5 &&
      !document.body.classList.contains('disable-scroll') &&
      !document.body.classList.contains('disable-scroll-body') &&
      !document.body.classList.contains('after-focusout')
    ) {
      this.header.classList.remove('animate');
    }

    /* If any dropdown or mega menu is open in the bottom bar, freeze collapse state */
    const openDropdown = this.header.querySelector('.bottom-bar details-dropdown[open]');
    if (openDropdown) {
      this._collapseLastY = scrollTop;
      return;
    }

    /* Nike Jordan-style collapse: only on pages where the active parent link has
       a corresponding sub-nav menu in the bottom bar (linklists[handle] exists and
       has links). Even if a link gets active-parent-link from URL matching, if no
       .menu-{handle} element exists there is nothing to show -- so don't collapse. */
    const activeLink = this.header.querySelector('.main-header-wrapper .active-parent-link');
    let hasActiveSubNav = false;
    if (activeLink) {
      /* Extract handle from classes like "link-shop", "link-events" */
      const handleClass = Array.from(activeLink.classList)
        .find(c => c.startsWith('link-') && c !== 'link-metafield-true' && c !== 'link-metafield-false');
      const handle = handleClass ? handleClass.slice(5) : null;
      /* Only true if a matching bottom-bar menu element was rendered for this handle */
      hasActiveSubNav = !!(handle && this.header.querySelector(`.bottom-bar-wrapper .menu-${handle}`));
    }

    if (!hasActiveSubNav) {
      /* Ensure header is always fully visible on pages without a real sub-nav */
      if (this.header.classList.contains('header--collapsed')) {
        this.header.classList.remove('header--collapsed');
      }
      this._collapseLastY = scrollTop;
      return;
    }

    /* Nike Jordan-style collapse: hide main header on scroll-down, show on scroll-up.
       Uses asymmetric hysteresis: small delta to collapse (3px), larger delta to
       reveal (30px) so casual micro-scrolls don't flicker the header back. */
    const COLLAPSE_THRESHOLD = 80;
    const DOWN_DELTA = 3;
    const UP_DELTA = 30;
    const now = performance.now();
    const cooldown = this._collapseCooldown || 0;

    if (now - cooldown < 400) {
      /* Cooldown: absorb layout-shift bounce without moving baseline */
      return;
    } else if (scrollTop <= COLLAPSE_THRESHOLD) {
      /* Near top of page: always show full header */
      if (this.header.classList.contains('header--collapsed')) {
        this._smoothReveal();
        this._collapseCooldown = now;
        this._updateCollapsedHeight(false);
      }
      this._collapseLastY = scrollTop;
    } else if (scrollTop > (this._collapseLastY || 0) + DOWN_DELTA) {
      /* Scrolling down: collapse quickly */
      if (!this.header.classList.contains('header--collapsed')) {
        this._smoothCollapse();
        this._collapseCooldown = now;
        this._updateCollapsedHeight(true);
      }
      this._collapseLastY = scrollTop;
    } else if (scrollTop < (this._collapseLastY || 0) - UP_DELTA) {
      /* Scrolling up with intent: reveal full header */
      if (this.header.classList.contains('header--collapsed')) {
        this._smoothReveal();
        this._collapseCooldown = now;
        this._updateCollapsedHeight(false);
      }
      this._collapseLastY = scrollTop;
    } else {
      this._collapseLastY = scrollTop;
    }
  }

  /* Smooth collapse: capture real height, pin it, then let CSS transition to 0 */
  _smoothCollapse() {
    const mh = this.header.querySelector('.main-header');
    if (mh) {
      const h = mh.offsetHeight;
      mh.style.setProperty('--main-header-h', h + 'px');
      mh.offsetHeight; /* force reflow so browser registers the start value */
    }
    this.header.classList.add('header--collapsed');
  }

  /* Smooth reveal: remove collapsed class, set --main-header-h to target height
     so the transition animates from 0 back up to the real height. */
  _smoothReveal() {
    const mh = this.header.querySelector('.main-header');
    this.header.classList.remove('header--collapsed');
    if (mh) {
      /* After removing collapsed, read the natural height */
      requestAnimationFrame(() => {
        const h = mh.scrollHeight;
        mh.style.setProperty('--main-header-h', h + 'px');
      });
    }
  }

  /* Update --header-height so mega-menu top: var(--parent-height) aligns
     with the actual visible header, not the full uncollapsed height. */
  _updateCollapsedHeight(isCollapsed) {
    if (!this.header) return;
    if (isCollapsed) {
      const bottomBar = this.header.querySelector('.bottom-bar');
      const announcementBars = this.header.parentElement?.querySelectorAll('.shopify-section-group-header-group > :not(.shopify-section-header)') || [];
      let abHeight = 0;
      announcementBars.forEach(el => { abHeight += el.offsetHeight || 0; });
      const barH = bottomBar ? bottomBar.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-height', `${abHeight + barH}px`);
    } else {
      /* Restore full height on next measure */
      this._scheduleMeasure();
    }
  }

  hide() {
    if (!this.header) return;

    if (!this.header.classList.contains('shopify-section-header-sticky')) {
      this.disableTransitionForMs(300);
    }

    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'disable-visibility');
    setTimeout(() => {
      if (this.header) this.header.classList.remove('disable-visibility');
    }, 100);
  }

  reveal() {
    if (!this.header) return;

    if (!this.header.classList.contains('shopify-section-header-sticky')) {
      this.disableTransitionForMs(300);
    }

    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden', 'disable-visibility');
  }

  reset() {
    if (!this.header) return;

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate',
      'transition-none',
      'disable-visibility'
    );
  }
}

customElements.define('sticky-header', StickyHeader);

  class SearchElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
        if(!this.querySelector('.search-field__text')) return
        this.querySelector('.search-field__text').addEventListener('focus', () => {
            const scrollY = window.scrollY || window.pageYOffset;
            document.body.dataset.scrollY = scrollY;
            document.body.style.top = `-${scrollY}px`;
            document.body.classList.add('disable-scroll-body')
        })
        this.querySelector('.search-field__text').addEventListener('focusout', () => {
            this.querySelector('.search-field__text').value = ''
            if (document.body.classList.contains('disable-scroll-body')) {
                document.body.classList.add('after-focusout')
                document.documentElement.style.scrollBehavior = 'auto'
                const scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
                document.body.classList.remove('disable-scroll-body')
                document.body.style.top = '';
                window.scrollTo({ top: scrollY, left: 0, behavior: 'auto' });
            }
            setTimeout(() => {document.documentElement.style.scrollBehavior = 'smooth'},10)
            setTimeout(() => document.body.classList.remove('after-focusout'), 200)
        })
    }

  }
  customElements.define('search-element', SearchElement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-drawer"]) return;
  try {
    
  /* The X close button has data-modal-toggle-menu-dawer, which fires through ALL
     <menu-drawer> custom element document-level listeners (5 in the header for
     different layout breakpoints). That causes an even number of toggles on some
     builds, bouncing the drawer back open. Fix: intercept the click, stop it from
     reaching those handlers, then click the [data-modal-toggle] overlay directly
     (the Volume theme's single, canonical close mechanism for drawers). */
  const closeBtn = document.querySelector('.menu-drawer-button-wrapper .button-close[data-modal-toggle-menu-dawer]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      const overlay = document.querySelector('[data-modal-toggle]');
      if (overlay) overlay.click();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
